import AuthorizedPersonModal from '@/views/Client/AuthorizedPersonModal.vue' //
import AuthorizedPersonKycReportModal from '@/views/Client/AuthorizedPersonKycReportModal.vue' //
import RpsMatchSelectionModal from '@/views/Client/RpsMatchSelectionModal.vue' //
import DnbReportFetchModal from '@/views/Client/components/DnbReportFetchModal.vue' //
import DnbSearchResultsModal from '@/views/Client/DnbSearchResultsModal.vue' //
import ClientItemModal from '@/views/Client/ClientItemModal.vue' //
import BillingEntityModal from '@/views/Admin/BillingEntityModal.vue'
import UnitTypeCreateModal from '@/views/UnitType/UnitTypeCreateModal.vue' //
// // import ContractUploadModal from '@/views/Contract/ContractUploadModal.vue' //
import UploadContractFileModal from '@/components/shared/files/UploadContractFileModal.vue' //
import UploadClientFileModal from '@/views/Client/components/files/UploadClientFileModal.vue'
import InvoiceUploadModal from '@/views/OperationsManagement/InvoiceUploadModal.vue' //
import SelectUnitTypeModal from '@/views/ClickAndFinance/modals/SelectUnitTypeModal.vue' //
import SelectClientModal from '@/views/ClickAndFinance/modals/SelectClientModal.vue' //
import ResetFormModal from '@/views/ClickAndFinance/modals/ResetFormModal.vue' //
import ContractSavedModal from '@/views/ClickAndFinance/modals/ContractSavedModal.vue' //
import CreateTokenModal from '@/views/Token/CreateTokenModal.vue' //
import EquipmentConnectivityModal from '@/views/Unit/components/EquipmentConnectivityModal.vue' //
import EquipmentNotesModal from '@/views/Unit/components/EquipmentNotesModal.vue' //
import InviteItemModal from '@/views/Users/InviteItemModal.vue' //
import MaintenanceModal from '@/views/Contract/MaintenanceModal.vue' //
import ContractSubItemsModal from '@/views/Contract/ContractSubItemsModal.vue' //
import ContractFilesModal from '@/views/Contract/ContractFilesModal.vue' //
import FlexibilityLevelEditModal from '@/views/Contract/FlexibilityLevelEditModal.vue' //
import ChangeOperatorModal from '@/views/Contract/ChangeOperatorModal.vue' //
import ShareContractsModal from '@/views/Contract/ShareContractsModal.vue'
import UserRolesModal from '@/views/Users/UserRolesModal.vue' //
import InternalUserRolesModal from '@/views/Users/InternalUserRolesModal.vue' //
import CountersigningDateModal from '@/views/Contract/CountersigningDateModal.vue' //
import CustomerUidModal from '@/views/Contract/CustomerUidModal.vue' //
import ContractResidualValuesTableModal from '@/views/Contract/components/ContractResidualValuesTableModal.vue' //
import CreateRoleModal from '@/views/Admin/components/CreateRoleModal.vue' //
import EditRoleModal from '@/views/Admin/components/EditRoleModal.vue' //
import ConfirmActionModal from './ConfirmActionModal.vue'
import CreateItemModal from './CreateItemModal.vue'
import ValidationErrorsModal from './ValidationErrorsModal.vue'
import ActAsUserModal from '@/components/ActAsUserModal.vue'
import JsonEditorModal from '@/components/JsonEditorModal.vue'
import ConfirmBulkSendModal from '@/views/OperationsManagement/components/ConfirmBulkSendModal.vue'
import ConfirmBulkMarkAsPaidModal from '@/views/OperationsManagement/components/ConfirmBulkMarkAsPaidModal.vue'
import EquipmentPlannedUtilizationModal from './EquipmentPlannedUtilizationModal.vue'
import ConfirmTypeClone from '@/views/UnitType/modals/ConfirmTypeClone.vue' //
import AddAuthorizedPeopleFromDnbDataModal from '@/views/Client/components/AddAuthorizedPeopleFromDnbDataModal.vue' //
import TranslationEditorModal from '@/views/Admin/TranslationEditorModal.vue'
import ComplianceReportCreateModal from '@/views/Client/ComplianceReportCreateModal.vue'
import ComplianceReportApproveModal from '@/views/Client/ComplianceReportApproveModal.vue'

export default {
    AuthorizedPersonModal,
    AuthorizedPersonKycReportModal,
    RpsMatchSelectionModal,
    DnbReportFetchModal,
    DnbSearchResultsModal,
    ClientItemModal,
    BillingEntityModal,
    UnitTypeCreateModal,
    // // ContractUploadModal,
    UploadContractFileModal,
    UploadClientFileModal,
    InvoiceUploadModal,
    SelectUnitTypeModal,
    SelectClientModal,
    ResetFormModal,
    ContractSavedModal,
    CreateTokenModal,
    EquipmentConnectivityModal,
    InviteItemModal,
    CountersigningDateModal,
    CustomerUidModal,
    ContractResidualValuesTableModal,
    MaintenanceModal,
    ContractSubItemsModal,
    ContractFilesModal,
    FlexibilityLevelEditModal,
    ChangeOperatorModal,
    ShareContractsModal,
    UserRolesModal,
    InternalUserRolesModal,
    ConfirmActionModal,
    CreateItemModal,
    EquipmentNotesModal,
    CreateRoleModal,
    EditRoleModal,
    ValidationErrorsModal,
    ActAsUserModal,
    JsonEditorModal,
    ConfirmBulkSendModal,
    ConfirmBulkMarkAsPaidModal,
    EquipmentPlannedUtilizationModal,
    ConfirmTypeClone,
    AddAuthorizedPeopleFromDnbDataModal,
    TranslationEditorModal,
    ComplianceReportCreateModal,
    ComplianceReportApproveModal,
}
